<template>
  <div id="publicClass_details">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <!-- bottombox end -->
    <div class="hotgkt">
      <div class="BreadcrumbNavigation">
        您当前所在位置：<a href="/">首页</a> &gt;&gt;
        <router-link :to="{ path: '/course_list' }">课程列表</router-link>
        &gt;&gt; <span>{{ Title }}</span>
      </div>
    </div>
    <!-- hotgkt end -->
    <div class="box_top clearfix">
      <h2>{{ Title }}</h2>
      <p class="p1">
        <span>{{ ClassTypeName }}</span>
      </p>
      <p class="p1">
        <span>{{ CourseTypeName }}</span>
      </p>
      <p class="p2">{{ ApplyStudentType }}</p>
      <p class="p3">{{ ServiceType }}</p>
    </div>
    <!-- box_top end -->
    <div id="position" class="pos_f" v-if="position">
      <div class="position_left clearfix">
        <div id="tab-tilte2" :class="{ live_course: live_course }">
          <ul>
            <li @click="curClick(0)" :class="{ active: cur == 0 }">课程介绍</li>
            <li @click="curClick(1)" :class="{ active: cur == 1 }">课程目录</li>
            <li @click="curClick(2)" :class="{ active: cur == 2 }">师资介绍</li>
            <li @click="curClick(3)" :class="{ active: cur == 3 }">学员反馈</li>
            <li
              @click="curClick(4)"
              :class="{ active: cur == 4 }"
              v-if="live_course"
            >
              下设班级
            </li>
          </ul>
          <i :style="{ transform: 'translateX(' + this.cur * 122 + 'px)' }"></i>
        </div>
        <!-- <div class="position_right clearfix">
          <span class="ckhf" v-if="anys===0" @click="ljyy">关注</span>
          <span class="yyy" v-else @click="ljyy">已关注</span>
          <span class="ljyy" @click="course_order">立即购买</span>
        </div> -->
      </div>
    </div>
    <!-- position end -->
    <div class="main">
      <div class="box_top_b">
        <!-- <div class="box_top_b_1">
          <strong><i>{{ClassHour}}课时</i>/￥{{Price}}</strong>
          <span class="ljyy" @click="course_order">立即购买</span>
          <span class="ckhf" v-if="anys===0" @click="ljyy">关注</span>
          <span class="yyy" v-else @click="ljyy">已关注</span>
        </div> -->
        <div class="box_top_b_2"><strong>优惠活动：</strong></div>
      </div>
      <div class="main_top">
        <div id="tab-tilte1" :class="{ live_course: live_course }">
          <ul>
            <li @click="curClick(0)" :class="{ active: cur == 0 }">课程介绍</li>
            <li @click="curClick(1)" :class="{ active: cur == 1 }">课程目录</li>
            <li @click="curClick(2)" :class="{ active: cur == 2 }">师资介绍</li>
            <li @click="curClick(3)" :class="{ active: cur == 3 }">学员反馈</li>
            <li
              @click="curClick(4)"
              :class="{ active: cur == 4 }"
              v-if="live_course"
            >
              下设班级
            </li>
          </ul>
          <i :style="{ transform: 'translateX(' + this.cur * 122 + 'px)' }"></i>
        </div>
        <!-- tab-tilte end -->
        <div id="tab-content">
          <div v-show="cur == 0">
            <div class="introduction">
              <video
                width="1020"
                height="574"
                controls
                :poster="CoverImg"
                v-if="CoverVideo"
              >
                <source :src="CoverVideo" />
                您的浏览器不支持 video 标签。
              </video>
              <div class="centent">
                <p>{{ SynopsisText }}</p>
              </div>
            </div>
          </div>
          <!-- tab-tilte 0 end -->
          <div v-show="cur == 1">
            <div class="catalog">
              <div class="catalog_chapter" v-for="(items, index) in ewArray">
                <div v-for="(item, indexs) in items">
                  <div class="catalog_chapter_p" v-if="item.Type == 1">
                    <i></i><span>第{{ index + 1 }}章</span>{{ item.Title }}
                  </div>
                  <div class="catalog_section" v-if="item.Type == 2">
                    <div class="catalog_section_p">
                      <span>第{{ indexs }}节</span>
                      <i>
                        <img
                          src="../../assets/courselist/live.png"
                          v-if="item.IsTrial"
                        />
                        <img src="../../assets/courselist/video.png" v-else />
                      </i>
                      {{ item.Title }}
                      <strong v-if="!item.IsTrial"> {{ item.Duration }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- tab-tilte 1 end -->
          <div v-show="cur == 2">
            <div class="teacher">
              <div class="centent">
                <!-- <p><img :src="CoverImg " alt=""></p> -->
                <p v-html="ClassPrice"></p>
              </div>
            </div>
          </div>
          <!-- tab-tilte 2 end -->
          <div v-show="cur == 3">
            <div class="feedback">
              <!-- centent end -->
              <div class="feedback_list clearfix">
                <div class="feedback_list_title" v-if="Average">
                  <i></i><span>评价</span>{{ Count }}
                  <el-rate
                    v-model="Average"
                    disabled
                    :colors="colors"
                  ></el-rate>
                </div>
                <div class="clearfix">
                  <dl
                    class="clearfix"
                    v-for="(item, index) in CommentInfo.Comments"
                  >
                    <dt><img :src="item.HeadUrl" /></dt>
                    <dd>
                      <div class="p1 clearfix">
                        <strong>{{ item.NickName }}</strong>
                        <el-rate
                          v-model="item.Score / 2"
                          disabled
                          :colors="colors"
                        ></el-rate
                        ><span>{{ item.AddTime }}</span>
                      </div>
                      <div class="p2 clearfix">
                        <span v-for="(item1, index) in objList[index]">{{
                          item1
                        }}</span>
                      </div>
                      <div class="p3 clearfix">{{ item.FeedBack }}</div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <!-- tab-tilte 3 end -->
          <div v-show="cur == 4" v-if="live_course">
            <div class="theClass">
              <ul class="clearfix">
                <li
                  class="theClass_li"
                  v-for="(item, index) in CourseClasses"
                  tabindex="index"
                >
                  <h3>{{ item.Title }}</h3>
                  <p>
                    计划开班时间：{{ item.PlanOpenDate }}<br />
                    上课时间：{{ item.Describe }}
                  </p>
                  <div class="tc clearfix">
                    <strong>
                      <img :src="item.Staffs[0].HeadUrl" />
                    </strong>
                    <span>{{ item.Staffs[0].Name }}</span>
                    <!-- <div v-if="item.IsApply"> -->
                    <p v-if="!item.IsApply" @click="addCourse(index)">
                      加入该班级
                    </p>
                    <p v-else-if="index == 0">已加入该班级</p>
                    <!-- <p>加入该班级</p>
                      <p>加入该班级</p> -->
                    <!-- </div> -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- tab-tilte 4 end -->
        </div>
        <!-- tab-content end -->
      </div>
    </div>
    <!-- main end -->
    <!-- <div class="yycg_tan" v-if="ljyycg">
      <img src="../../assets/publicClass/yycg_tan.png" width="272">
      <h2>预约成功</h2>
      <p>课程动态我们会短信提醒您。<br>
        您可以到个人中心查询或取消该关注。</p>
      <span @click="closeTan">确定</span>
    </div> -->
    <!-- yycg_tan end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

export default {
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    
  },
  data() {
    return {
      tokenkey: "",
      anys: 0,
      Ids: "", //课程ID
      ljyycg: false, //判断是否已关注
      cur: 0,
      live_course: true, //判断是否为试听课
      scroll: "",
      position: false,
      Title: "", //标题
      ClassTypeName: "", //班型
      CourseTypeName: "", //课程分类
      ApplyStudentType: "", //适合的人群
      ServiceType: "", //包含服务
      ClassHour: "", //课时
      Price: "", //价格
      CoverVideo: "", //短视频
      CoverImg: "", //短视频封面
      SynopsisText: "", //课程介绍
      CourseCatalogue: "", //课程标题（课程目录）
      Catalogues: "", //课程目录
      ClassPrice: "", //师资介绍
      CommentInfo: "", //学员反馈
      Average: 0, //星星
      Count: 0, //数量
      Label: "",
      objList: {},
      CourseClasses: [], //下设班级列表
      CataloguesList: "",
      ewArray: [],
      ClassId: "", //班级Id

      colors: ["#99A9BF", "#F7BA2A", "#FF9900"]
    };
  },
  methods: {
    curClick(index) {
      let that = this;
      this.cur = index;
      //下设班级
      if (index == 4) {
        that.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/CourseClass?courseId=" +
              that.Ids,
            {
              headers: {
                "content-type": "application/json; charset=utf-8",
                token: that.tokenkey
              }
            }
          )
          .then(function(response) {
            that.CourseClasses = response.data.results;
            that.ClassId = response.data.results;
          })
          .catch(function(err) {
            // console.log(err);
            // console.log('数据错误');
          });
      }
    },
    menu() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.getElementById("tab-content").offsetTop + 500;
      // // console.log(offsetTop)
      if (this.scroll > offsetTop) {
        this.position = true;
      } else {
        this.position = false;
      }
    },
    //转换二维数组
    handelArray(array, arr = []) {
      if (array) {
        for (let i = 0; i < array.length; i++) {
          if (array[i].Type === 1) {
            arr.push([array[i]]);
          } else {
            if (arr.length == 0) {
              arr.push([array[i]]);
            } else {
              arr[arr.length - 1].push(array[i]);
            }
          }
        }
        return arr;
      }
    },
    //加入该班级
    addCourse(a) {
      let that = this;
      that.ClassId = that.CourseClasses[a].Id;
      this.$http
        .post(
          "https://schoolapi.eiceducation.com.cn/api/ChoiceClass",
          {
            CourseId: that.Ids,
            ClassId: that.ClassId
          },
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          //还未购买
          if (result.data.code == 2) {
            that.$message.error(result.data.msg);
          }
          //提示已预约
          // that.$message.error(result.data.msg);
        })
        .catch(function(error) {
          // console.log(error);
        });
    },
    //初始加载
    nowLoading() {
      let that = this;
      that.tokenkey = that.$cookies.get("token");
      //获取枚举列表
      let enumBox = sessionStorage.getItem("enum");
      that.enumList = JSON.parse(enumBox);
      window.addEventListener("scroll", this.menu);
      that.Ids = this.$route.query.Id;
      return new Promise(function(resolve, reject) {
        resolve(
          that.$http
            .get("https://schoolapi.eiceducation.com.cn/api/Course/" + that.Ids)
            .then(function(response) {
              // console.log(response.data.results)
              that.Title = response.data.results.Title; //标题
              that.ClassTypeName = response.data.results.ClassTypeName; //班型
              that.CourseTypeName = response.data.results.CourseTypeName; //课程分类
              that.ApplyStudentType = response.data.results.ApplyStudentType; //适合人群
              that.ServiceType = response.data.results.ServiceType; //包含服务
              that.ClassHour = response.data.results.ClassHour; //课时
              that.Price = response.data.results.Price; //价格
              that.CoverVideo = response.data.results.CoverVideo; //短视频
              that.CoverImg = response.data.results.CoverImg; //短视频封面
              that.SynopsisText = response.data.results.SynopsisText; //课程介绍
              //课程目录
              that.Catalogues = response.data.results.Catalogues; //课程标题
              that.CataloguesList =
                response.data.results.Catalogues[0].Catalogues; //课程标题
              that.ewArray = that.handelArray(that.CataloguesList); //处理数据
              //师资介绍
              that.ClassPrice = response.data.results.ClassPrice;
              //学员反馈
              that.CommentInfo = response.data.results.CommentInfo;
              //星星
              that.Average = parseFloat(
                response.data.results.CommentInfo.Average / 2
              );
              //数量
              that.Count = response.data.results.CommentInfo.Count;
              //标签
              that.Label = response.data.results.CommentInfo.Comments;
              let objBox = {};
              that.Label.forEach(function(item, i) {
                objBox[i] = item.Label.split(",");
              });
              that.objList = objBox;
              //是否有下设班级
              that.live_course = response.data.results.CourseClasses;
              //下设班级列表
              // that.CourseClasses = response.data.results.CourseClasses
            })
            .catch(function(err) {
              // console.log(err);
              // console.log('数据错误');
            })
        );
      });
    }
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    that.nowLoading();
  }
};
</script>

<style scoped>
.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt {
  background: #fafafa;
}

.BreadcrumbNavigation {
  width: 1180px;
  text-align: left;
  font-size: 16px;
  color: #333;
  line-height: 56px;
  margin: 0 auto;
}

.BreadcrumbNavigation a {
  font-size: 16px;
  color: #333;
}

.BreadcrumbNavigation span {
  font-size: 16px;
  color: #ff4253;
}

.box_top {
  width: 100%;
  height: 360px;
  background: url(../../assets/publicClass/Fixedbackground.png) top no-repeat;
  padding-top: 60px;
  box-sizing: border-box;
  position: relative;
}

.box_top h2 {
  text-align: center;
  font-weight: normal;
  font-size: 30px;
  color: #fff;
  line-height: 30px;
  margin-bottom: 24px;
}

.box_top .p1 {
  text-align: center;
  height: 32px;
  margin-bottom: 20px;
}

.box_top .p1 span {
  display: inline-block;
  min-width: 88px;
  height: 32px;
  background: linear-gradient(90deg, #424242 0%, #2a2a2a 100%);
  border-radius: 18px;
  font-size: 14px;
  color: #fff;
  line-height: 32px;
  margin: 0 8px;
  padding: 0 15px;
  box-sizing: border-box;
}

.box_top .p2 {
  text-align: center;
  font-size: 16px;
  line-height: 16px;
  color: #fff;
  margin-bottom: 24px;
}

.box_top .p3 {
  width: 680px;
  height: 38px;
  line-height: 38px;
  background: #222222;
  border-radius: 26px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  margin: 0 auto;
  margin-bottom: 16px;
}

.main {
  background: #fafafa;
  padding-bottom: 70px;
  position: relative;
}

.box_top_b {
  width: 1180px;
  background: #ffffff;
  box-shadow: 0px 2px 6px 11px rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  margin: 0 auto;
  position: relative;
  top: -25px;
}

.box_top_b .box_top_b_1 {
  height: 88px;
  padding-right: 40px;
}

.box_top_b .box_top_b_1 strong {
  font-size: 28px;
  color: #333;
  line-height: 88px;
  padding-left: 50px;
  float: left;
  font-weight: normal;
}

.box_top_b .box_top_b_1 strong i {
  height: 88px;
  display: inline-block;
  font-size: 20px;
  float: left;
  line-height: 90px;
}

.box_top_b .box_top_b_1 span {
  float: right;
  display: block;
  width: 160px;
  height: 42px;
  line-height: 42px;
  box-shadow: 0px 0px 10px 6px #f5f6f6;
  border-radius: 23px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  margin-top: 23px;
  cursor: pointer;
  cursor: pointer;
  margin-left: 8px;
}

.ljyy {
  background: linear-gradient(90deg, #ff7c71 0%, #ff3250 100%);
}

.yyy {
  cursor: default;
  background: linear-gradient(180deg, #2fd672 0%, #33c059 100%);
}

.ckhf {
  background: linear-gradient(90deg, #7782fb 0%, #4e5cf6 100%);
}

.box_top_b .box_top_b_2 {
  /* border-top: 1px #d5d5d5 solid; */
  font-size: 16px;
  color: #333;
  padding: 30px 50px;
  line-height: 24px;
  text-align: left;
}

.box_top_b .box_top_b_2 strong {
  font-weight: normal;
}

.main_top {
  width: 1180px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
  padding: 43px 0;
}

#tab-tilte1 {
  height: 36px;
  position: relative;
}

#tab-tilte1 i {
  display: block;
  width: 32px;
  height: 2px;
  background: #4e5cf6;
  border-radius: 2px;
  position: absolute;
  left: 391px;
  bottom: 0;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

#tab-tilte1.live_course i {
  left: 330px;
}

#tab-tilte1 ul {
  width: 488px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}

#tab-tilte1.live_course ul {
  width: 610px;
}

#tab-tilte1 ul li {
  width: 122px;
  font-size: 20px;
  color: #333;
  text-align: center;
}

#tab-tilte1 ul li.active {
  color: #4e5cf6;
}

#tab-content {
  border-top: 1px #d5d5d5 solid;
  padding-top: 32px;
}

.main_top .introduction {
  padding: 0 80px;
}

.main_top .introduction .centent {
  padding-top: 20px;
}

.main_top .introduction .centent p {
  text-align: left;
  font-size: 14px;
  line-height: 24px;
}

.main_top .catalog {
  width: 1020px;
  margin: 0 auto;
}

.main_top .catalog .catalog_chapter {
  margin-bottom: 36px;
}

.main_top .catalog .catalog_chapter_p {
  padding: 12px 10px;
  font-size: 18px;
  color: #333;
  line-height: 28px;
  text-align: left;
  background: #f5f6f6;
}

.main_top .catalog .catalog_chapter_p span {
  float: left;
  margin-right: 20px;
}

.main_top .catalog .catalog_chapter_p i {
  display: inline-block;
  width: 6px;
  height: 12px;
  background: #d5d5d5;
  border-radius: 3px;
  vertical-align: middle;
  float: left;
  margin-right: 12px;
  margin-top: 8px;
}

.main_top .catalog .catalog_section_p {
  border-bottom: 1px #d5d5d5 solid;
  padding: 32px 28px;
  text-align: left;
  font-size: 16px;
  color: #333;
  line-height: 28px;
}

.main_top .catalog .catalog_section_p span {
  float: left;
  font-size: 16px;
  color: #333;
}

.main_top .catalog .catalog_section_p i {
  display: inline-block;
  width: 28px;
  height: 28px;
  vertical-align: middle;
  float: left;
  padding-left: 11px;
  margin-right: 20px;
}

.main_top .catalog .catalog_section_p strong {
  float: right;
  font-size: 16px;
  color: #999;
  font-weight: normal;
}

.main_top .teacher {
  padding: 0 80px;
}

.main_top .teacher .centent {
  padding-top: 20px;
}

.main_top .teacher .centent p {
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 20px;
}

.main_top .teacher .centent p img {
  width: 100%;
}

.main_top .feedback {
  padding: 0 80px;
}

.main_top .feedback .centent {
  padding-top: 20px;
}

.main_top .feedback .centent p {
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 20px;
}

.main_top .feedback .centent p img {
  width: 100%;
}

.el-icon-star-on:before {
  font-size: 120px;
  color: #f00;
}

.feedback_list_title {
  width: 1020px;
  height: 52px;
  background: #f5f6f6;
  border-radius: 8px;
  text-align: left;
  font-size: 18px;
  color: #333;
  line-height: 52px;
  padding-left: 10px;
  padding-right: 23px;
  margin-bottom: 20px;
}

.feedback_list_title i {
  display: block;
  width: 6px;
  height: 12px;
  background: #d5d5d5;
  border-radius: 3px;
  vertical-align: middle;
  float: left;
  margin-right: 20px;
  margin-top: 22px;
}

.feedback_list_title span {
  float: left;
  font-size: 18px;
  color: #333;
}

.feedback_list_title .el-rate {
  float: right;
  margin-top: 6px;
}

/deep/ .feedback_list_title .el-rate__icon {
  font-size: 40px;
}

.feedback_list dl {
  border-bottom: 1px #d5d5d5 solid;
  padding: 17px 12px;
  padding-left: 28px;
}

.feedback_list dl dt {
  border: 3px #f5f6f6 solid;
  width: 42px;
  height: 42px;
  overflow: hidden;
  border-radius: 24px;
  float: left;
  margin-right: 12px;
}

.feedback_list dl dt img {
  display: block;
  width: 100%;
}

.feedback_list dl dd {
  width: 920px;
  float: left;
  text-align: left;
}

.feedback_list dl dd .p1 {
  height: 28px;
  margin-bottom: 4px;
}

.feedback_list dl dd .p1 strong {
  color: #333;
  font-size: 16px;
  line-height: 28px;
  float: left;
  margin-right: 8px;
}

.feedback_list dl dd .p1 .el-rate {
  float: left;
  margin-top: 2px;
}

/deep/ .feedback_list dl dd .p1 .el-rate__icon {
  font-size: 22px;
}

.feedback_list dl dd .p1 span {
  float: right;
  font-size: 12px;
  line-height: 22px;
  color: #666;
  padding-top: 6px;
}

.feedback_list dl dd .p2 {
  height: 20px;
  margin-bottom: 10px;
}

.feedback_list dl dd .p2 span {
  display: inline-block;
  padding: 0 15px;
  line-height: 20px;
  background: #7782fb;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  margin-right: 12px;
}

.feedback_list dl dd .p3 {
  font-size: 12px;
  color: #666666;
  line-height: 20px;
}

.main_top .theClass {
  padding: 0 80px;
}

.main_top .theClass ul li {
  border-bottom: 1px #d5d5d5 solid;
  padding-bottom: 12px;
  margin-bottom: 16px;
  text-align: left;
}

.main_top .theClass ul li h3 {
  font-size: 20px;
  color: #333333;
  line-height: 30px;
  font-weight: normal;
}

.main_top .theClass ul li p {
  font-size: 16px;
  color: #666666;
  line-height: 24px;
  margin-bottom: 8px;
}

.main_top .theClass ul li .tc strong {
  display: block;
  border: 2px #f5f6f6 solid;
  width: 28px;
  height: 28px;
  overflow: hidden;
  float: left;
  border-radius: 16px;
  margin-right: 8px;
  margin-top: 2px;
  background: url(../../assets/courselist/morimg.png) center no-repeat;
  background-size: 100% auto;
}

.main_top .theClass ul li .tc strong img {
  width: 100%;
}

.main_top .theClass ul li .tc span {
  display: block;
  line-height: 36px;
  font-size: 16px;
  color: #333;
  float: left;
}

.main_top .theClass ul li .tc p {
  display: block;
  width: 120px;
  height: 34px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #d5d5d5;
  line-height: 34px;
  text-align: center;
  font-size: 16px;
  color: #333;
  float: right;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.main_top .theClass ul li .tc p:hover {
  color: #fff;
  background: #4e5cf6;
  border-color: #4e5cf6;
  cursor: pointer;
}

#position {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(153, 153, 153, 0.5);
}

#position .position_left {
  width: 1180px;
  margin: 0 auto;
  padding: 10px 0;
}

#tab-tilte2 {
  width: 839px;
  float: left;
  position: relative;
}

#tab-tilte2 i {
  display: block;
  width: 24px;
  height: 4px;
  background: #4e5cf6;
  border-radius: 5px;
  position: absolute;
  left: 224px;
  bottom: 0;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

#tab-tilte2.live_course i {
  left: 162px;
}

#tab-tilte2 ul {
  width: 488px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}

#tab-tilte2.live_course ul {
  width: 610px;
}

#tab-tilte2 ul li {
  width: 122px;
  font-size: 16px;
  color: #333;
  text-align: center;
  line-height: 16px;
  padding: 13px 0;
}

#tab-tilte2 ul li.active {
  color: #4e5cf6;
}

#position .position_right {
  float: right;
}

#position .position_right strong {
  width: 800px;
  display: block;
  float: left;
  height: 42px;
  line-height: 42px;
  color: #333;
  font-size: 24px;
  text-align: left;
  font-weight: normal;
}

#position .position_left span {
  display: block;
  width: 160px;
  height: 42px;
  border-radius: 23px;
  float: left;
  font-size: 16px;
  text-align: center;
  line-height: 42px;
  color: #fff;
  cursor: pointer;
  margin-left: 8px;
}

.yycg_tan {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 460px;
  height: 560px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(102, 102, 102, 0.6);
  border-radius: 12px;
  margin-left: -230px;
  margin-top: -280px;
  box-sizing: border-box;
  text-align: center;
}

.yycg_tan img {
  margin: 0 auto;
  margin-top: 34px;
}

.yycg_tan h2 {
  font-size: 20px;
  text-align: center;
  color: #333333;
  line-height: 24px;
  margin-top: -8px;
  margin-bottom: 30px;
}

.yycg_tan p {
  margin: 0 auto;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  margin-bottom: 38px;
}

.yycg_tan span {
  display: block;
  width: 160px;
  height: 48px;
  background: linear-gradient(90deg, #7782fb 0%, #4e5cf6 100%);
  border-radius: 30px;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  line-height: 48px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/page2/courseList/course_auxiliary.vue